var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgBludce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 38.75C35.625 30.125 28.625 23.125 20 23.125C11.375 23.125 4.375 30.125 4.375 38.75",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7188 27.625C12.25 29 10.8125 32.375 10.8125 35.625L13.7188 27.625Z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 27.0625C11.6563 28.5 10.0312 32 10.0312 35.625C10.0312 36.0625 10.375 36.4062 10.8125 36.4062C11.25 36.4062 11.5938 36.0625 11.5938 35.625C11.5938 32.5937 12.9688 29.4062 14.25 28.2187C14.5625 27.9375 14.5625 27.4375 14.2813 27.125C14 26.7812 13.5 26.7812 13.1875 27.0625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 37.9688H36.375C36 30.3438 30.4375 24.0625 23.125 22.6562V20.7812C23.125 19.0625 21.7188 17.6562 20 17.6562C18.2812 17.6562 16.875 19.0625 16.875 20.7812V22.6562C9.5625 24.0625 3.96875 30.3438 3.625 37.9688H1.25C0.8125 37.9688 0.46875 38.3125 0.46875 38.75C0.46875 39.1875 0.8125 39.5312 1.25 39.5312H38.75C39.1875 39.5312 39.5312 39.1875 39.5312 38.75C39.5312 38.3125 39.1875 37.9688 38.75 37.9688ZM18.4375 20.7812C18.4375 19.9062 19.125 19.2188 20 19.2188C20.875 19.2188 21.5625 19.9062 21.5625 20.7812V22.4062C21.0625 22.3437 20.5312 22.3438 20 22.3438C19.4688 22.3438 18.9375 22.375 18.4375 22.4062V20.7812ZM20 23.9062C27.9375 23.9062 34.4062 30.1562 34.8125 37.9688H5.1875C5.59375 30.1562 12.0625 23.9062 20 23.9062Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 22.3438H30.9375C30.5 22.3438 30.1562 22.6875 30.1562 23.125C30.1562 23.5625 30.5 23.9062 30.9375 23.9062H38.75C39.1875 23.9062 39.5312 23.5625 39.5312 23.125C39.5312 22.6875 39.1875 22.3438 38.75 22.3438Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 25.4688H35C34.5625 25.4688 34.2188 25.8125 34.2188 26.25C34.2188 26.6875 34.5625 27.0312 35 27.0312H38.75C39.1875 27.0312 39.5312 26.6875 39.5312 26.25C39.5312 25.8125 39.1875 25.4688 38.75 25.4688Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 28.5938H37.1875C36.75 28.5938 36.4062 28.9375 36.4062 29.375C36.4062 29.8125 36.75 30.1562 37.1875 30.1562H38.75C39.1875 30.1562 39.5312 29.8125 39.5312 29.375C39.5312 28.9375 39.1875 28.5938 38.75 28.5938Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBludce);
export default __webpack_public_path__ + "static/media/bludce.edbcbe1048537e45d5bda31c1e5c4f93.svg";
export { ForwardRef as ReactComponent };